var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PageHeader", {
        attrs: { title: "Account Settings", body: "Settings for your account" },
      }),
      _c("PasswordSettings"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }